type ApiClientConfig = {
  baseURL: string;
};

const createApiClient = ({ baseURL }: ApiClientConfig) => {
  const getAccessToken = () => {
    try {
      const raw = localStorage.getItem(
        `sb-${import.meta.env.VITE_SUPABASE_PROJECT_ID}-auth-token`,
      );
      if (!raw) return null;

      const parsed = JSON.parse(raw);
      return parsed.access_token || null;
    } catch {
      return null;
    }
  };

  const getAuthHeaders = () => {
    const token = getAccessToken();
    return token ? { Authorization: `Bearer ${token}` } : {};
  };

  return {
    async get<Response>(resource: string) {
      const response = await fetch(`${baseURL}/${resource}`, {
        headers: {
          'Content-Type': 'application/json',
          ...getAuthHeaders(),
        },
      });

      const body = await response.json();
      return body as Response;
    },

    async post<Response>(resource: string, data: unknown) {
      const response = await fetch(`${baseURL}/${resource}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...getAuthHeaders(),
        },
        body: JSON.stringify(data),
      });

      const body = await response.json();
      return body as Response;
    },
    async patch<Response>(resource: string, data: unknown) {
      const response = await fetch(`${baseURL}/${resource}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          ...getAuthHeaders(),
        },
        body: JSON.stringify(data),
      });

      const body = await response.json();
      return body as Response;
    },
    async delete<Response>(resource: string) {
      const response = await fetch(`${baseURL}/${resource}`, {
        method: 'DELETE',
        headers: {
          ...getAuthHeaders(),
        },
      });

      const body = await response.json();
      return body as Response;
    },
  };
};

export const apiClient = createApiClient({
  baseURL: import.meta.env.VITE_APP_BASE_URL!,
});
